<template>
  <img :src="require(`@/assets/svg/chips/${chip}.svg`)" />
</template>
<script>
export default {
  props: {
    chip: {
      type: String,
      default: 'blue',
    },
  },
};
</script>
